import config from './config'
import authController from './controllers/authController'
import productsController from './controllers/productsController'
import customersController from './controllers/customersController'
import usersController from './controllers/usersController'
import rolesController from './controllers/rolesController'
import storesController from './controllers/storesController'
import categoriesController from './controllers/categoriesController'
import messageController from './controllers/messageController'
import ordersController from './controllers/ordersController'
import basketsController from './controllers/basketsController'
import deliveryOptionsController from './controllers/deliveryOptionsController'
import resourcesController from './controllers/resourcesController'
import notificationsController from './controllers/notificationsController'
import variantsStockController from './controllers/variantsStockController'
import regionsController from './controllers/regionsController'
import departmentsController from './controllers/departmentsController'
import pollQuestionController from './controllers/pollQuestionController'
import feedbackController from './controllers/feedbackController'
import inspirationsController from './controllers/inspirationsController'
import tagsController from './controllers/tagsController'
import scheduledTasksController from './controllers/scheduledTasksController'
import triggersController from './controllers/triggersController'
import productWaitlistController from './controllers/productWaitlistController'
import eventsController from './controllers/eventsController'
import eventWaitlistController from './controllers/eventWaitlistController'
import activitiesController from './controllers/activitiesController'
import customerUserRelationshipsController from './controllers/customerUserRelationshipsController'
import variantsController from './controllers/variantsController'
import appointmentController from './controllers/appointmentController'
import calendarsController from './controllers/calendarsController'
import remoteConfigController from './controllers/remoteConfigController'
import productListController from './controllers/productListController'
import chatController from './controllers/chatController'

export class DigitalStoreSDK {
  constructor ({ baseUrl, authToken, onRefresh }) {
    config.setConfig({ baseUrl, authToken, onRefresh })
  }
  setConfig = config.setConfig
  auth = authController
  products = productsController
  customers = customersController
  users = usersController
  roles = rolesController
  stores = storesController
  categories = categoriesController
  messages = messageController
  orders = ordersController
  baskets = basketsController
  deliveryOptions = deliveryOptionsController
  resources = resourcesController
  notifications = notificationsController
  variantsStock = variantsStockController
  regions = regionsController
  departments = departmentsController
  pollQuestions = pollQuestionController
  feedback = feedbackController
  inspirations = inspirationsController
  tags = tagsController
  scheduledTasks = scheduledTasksController
  triggers = triggersController
  productWaitlist = productWaitlistController
  events = eventsController
  eventWaitlist = eventWaitlistController
  activities = activitiesController
  customerUserRelationships = customerUserRelationshipsController
  variants = variantsController
  appointments = appointmentController
  calendars = calendarsController
  productLists = productListController
  remoteConfig = remoteConfigController
  chat = chatController
}

export default DigitalStoreSDK



// WEBPACK FOOTER //
// ../src/index.js